// extracted by mini-css-extract-plugin
module.exports = {"prompt":"ModuleName-moduleprompt-o3MC0"};